import React from "react";
import ReactDOM from "react-dom";
import "./style.css";
import App from "./App";
import "font-awesome/css/font-awesome.css";
import "bootstrap-social/bootstrap-social.css";

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById("root")
);
